var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseF flex-column-center"},[_c('div',{staticClass:"courseFImg"},[_c('ul',{staticClass:"ulImg"},_vm._l((_vm.itemData.tips),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.image}})])}),0)]),_c('div',{staticClass:"courseFBottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }